import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=ff71752a"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff71752a')) {
      api.createRecord('ff71752a', component.options)
    } else {
      api.reload('ff71752a', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=ff71752a", function () {
      api.rerender('ff71752a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/communications/Create.vue"
export default component.exports